module.exports = __webpack_public_path__ + "static/media/sv.b620d58e.svg";